import React, { PureComponent } from 'react'
import { Button, Table, Collapse } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'
import JsonModal from '../json_modal'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closeModalDialog, openModalDialog } from '../../actions/modal_dialog'

class DataSources extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
    }
  }

  render() {
    const { content, openModalDialog, closeModalDialog, isModalDialogOpen, data } = this.props

    const chevronClass = this.state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const alertClass = data.length > 0 ? 'label label-info-data' : 'label label-info'
    const borderRadius = this.state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          onClick={() => this.setState({ open: !this.state.open })}
          className='ibox-title'
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Data Sources</header>
          <span style={{ float: 'right' }} className={alertClass}>
            {data.length}
          </span>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {data ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Raw Data</th>
                      <th>Reference URL</th>
                      <th>Data Provider</th>
                      <th>Created</th>
                      <th>Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((entry, i) => (
                      <tr key={entry.id}>
                        <td>{entry.id}</td>
                        <td>
                          {entry.raw_data && (
                            <Button
                              bsPrefix='btn btn-default'
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => openModalDialog(entry.raw_data, e)}
                            >
                              View
                            </Button>
                          )}
                        </td>
                        <td>
                          {entry.reference_url ? (
                            <Button
                              href={entry.reference_url}
                              variant={'default'}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              Open
                            </Button>
                          ) : null}
                        </td>
                        <td>
                          {entry.data_provider && entry.data_provider.data_provider_type ? entry.data_provider.id : ''}
                        </td>
                        <td>{formatTimeString(entry.created)}</td>
                        <td>{formatTimeString(entry.updated)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
              <JsonModal
                isModalDialogOpen={isModalDialogOpen}
                content={content}
                title='Raw Data'
                close={closeModalDialog}
              />
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isModalDialogOpen: state.modalDialog.isModalDialogOpen,
  content: state.modalDialog.content,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModalDialog,
      closeModalDialog,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(DataSources)
